import { z } from 'zod';

export const CapstoneArtifactIdSchema = z.enum([
  'test-plan',
  'test-cases',
  'bug-reports',
  'rtm',
  'tsr',
  'journal',
]);

export const CapstoneTierSchema = z.enum(['required', 'bonus']);

export const CapstoneRubricRequiredIdSchema = z.enum([
  'r-test-plan-exit-criteria',
  'r-tc-template-fields',
  'r-tc-three-techniques',
  'r-br-severity-priority-pairs',
  'r-no-duplicate-bugs',
  'r-rtm-coverage-80',
  'r-tsr-go-no-go',
  'r-journal-3-entries',
  'r-ctfl-mock2-65',
]);

export const CapstoneRubricBonusIdSchema = z.enum([
  'b-master-documenter',
  'b-test-case-champion',
  'b-bug-hunter',
  'b-plan-pro',
  'b-reflective-practitioner',
  'b-tsr-architect',
  'b-atelier-resident',
  'b-a11y-aware',
  'b-capstone-champion',
]);

export const CapstoneArtifactProgressSchema = z.object({
  submitted: z.boolean(),
  submittedAt: z.string().optional(),
  notes: z.string().optional(),
});

/**
 * Capstone block ID · per-block capstone state.
 * W3.1 extension 2026-05-04 · was `'block-1'` literal · now union supports
 * Block 2 (Capstone B2 hybrid · W2.3 shipped) + Block 3 (Capstone B3 hybrid ·
 * W3.4 pending) + Block 4 (Sprint 17 capstone · Wave 4).
 */
export const CapstoneBlockIdSchema = z.enum(['block-1', 'block-2', 'block-3', 'block-4']);

export const CapstoneStateSchema = z.object({
  capstoneId: CapstoneBlockIdSchema,
  artifacts: z.record(CapstoneArtifactIdSchema, CapstoneArtifactProgressSchema),
  rubricRequired: z.record(CapstoneRubricRequiredIdSchema, z.boolean()),
  rubricBonus: z.record(CapstoneRubricBonusIdSchema, z.boolean()),
  selfRubricCompletedAt: z.string().optional(),
  releaseUnlockedAt: z.string().optional(),
});

export type CapstoneArtifactId = z.infer<typeof CapstoneArtifactIdSchema>;
export type CapstoneBlockId = z.infer<typeof CapstoneBlockIdSchema>;
export type CapstoneTier = z.infer<typeof CapstoneTierSchema>;
export type CapstoneRubricRequiredId = z.infer<typeof CapstoneRubricRequiredIdSchema>;
export type CapstoneRubricBonusId = z.infer<typeof CapstoneRubricBonusIdSchema>;
export type CapstoneArtifactProgress = z.infer<typeof CapstoneArtifactProgressSchema>;
export type CapstoneState = z.infer<typeof CapstoneStateSchema>;
